import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// Composant Breadcrumb simple pour remplacer celui qui manque
const Breadcrumb = ({ items }) => {
  return (
    <nav className="mb-6">
      <ol className="flex flex-wrap items-center text-sm text-gray-600">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <svg
                className="mx-2 h-4 w-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            )}
            {item.link === "#" ? (
              <span className="font-medium text-gray-800">{item.label}</span>
            ) : (
              <Link
                to={item.link}
                className="hover:text-[#57A863] hover:underline"
              >
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Breadcrumb;
